import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';

import { selectEnhancedExtraInfo } from '../selectors';
import { selectOrderedSelectCover } from '../selectors/selectCoverOptions';
import { selectDecline } from '../selectors/selectDecline';
import type { AppDispatch, AppStore, RootState } from '../store';

/*
 * To avoid clashes, we will use useAppDispatch and useAppSelector
 * throughout the app instead of plain `useDispatch` and `useSelector`
 */
export const useAppDispatch = useDispatch as () => AppDispatch;
export const useAppStore = useStore as () => AppStore;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/* Selector Hooks */
export const useStep = () => useAppSelector((state) => state.step);

export const useAppDetails = () => useAppSelector((state) => state.appDetails);
export const useBusinessDetails = () => useAppSelector((state) => state.businessDetails);
export const useSelectCover = () => useAppSelector(selectOrderedSelectCover);
export const useCoverDetails = () => useAppSelector((state) => state.coverDetails);
export const useExtraInfo = () => useAppSelector(selectEnhancedExtraInfo);
export const useQuote = () => useAppSelector((state) => state.quote);
export const usePayments = () => useAppSelector((state) => state.payments);
export const useAnalytics = () => useAppSelector((state) => state.analytics);
export const useDecline = () => useAppSelector(selectDecline);
export const usePayMyBill = () => useAppSelector((state) => state.payMyBill);
